import { useMemo } from 'react';
import { SwitchSize, SwitchProps } from './types';
import { SizeMap } from './constants';
import ReactSwitch from 'react-switch';

export const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  size = SwitchSize.Big,
  onColor = '#ff6800',
  offColor = '#f5f5f5',
  onHandleColor = '#ffffff',
  offHandleColor = '#ffffff',
}: SwitchProps) => {
  const { height, width, handleDiameter } = useMemo(
    () => SizeMap[size],
    [size],
  );

  return (
    <ReactSwitch
      handleDiameter={handleDiameter}
      height={height}
      width={width}
      uncheckedIcon={false}
      checkedIcon={false}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      onColor={onColor}
      offColor={offColor}
      onHandleColor={onHandleColor}
      offHandleColor={offHandleColor}
    />
  );
};
